import {
    HTTP
} from '@/utilities/http-common';

export default {
    namespaced: true,
    state: {
        count: 0
    },
    getters: {},
    mutations: {
        setCount(state, count) {
            state.count = count;
        },
        getCount(state) {
            return state.count;
        }
    },
    actions: {
        setSupervisorRequestsCount({
            commit
        }, count) {
            commit('setCount', count);
        },
        getSupervisorRequestsCount() {
            return HTTP.get('/kenya/supervisor-help-count');
        }
    },
}